<template>
  <div id="app">
    <ExcelSheet  
    fileName="TransferBookingExcel"
    :importData="importData" >
     
      <template v-slot:top>
       
        <div  v-if="checkTheRole([5,7])"
        style="width:300px ;float:left; ">
        <universal-input 
        label="fromDate"
        v-model="peopleFilter"
        :config="peopleFilterConfig"
      >
      </universal-input>
    </div>
 
    <div v-if="commissionBatchID == 0"
    style="width:300px ;float: left; padding-left:12px">
      <universal-input
      v-model="courseFromDate"
      :config="courseFromDateConfig"
      @input="handleCourseFromDateInput"
    ></universal-input>
  </div>



  <!-- @input="handleCourseFromDateInput" -->
  <!-- <div v-if="commissionBatchID != 0  "   style="width:300px ;float: left; padding-left:12px"> 
  <universal-input
  v-model="commissionBatchID"
  :config="commissionBatchConfig"

></universal-input>


  </div> -->

 
      </template>

    </ExcelSheet>
   
  </div>
</template>

<script setup>
 
import  ExcelSheet   from '@/components/Excel/excelSheet.vue'

import { getItem as  showExcel } from '@/api/commissionBatch'

import {CoachListForReport  } from '@/api/coach'
import moment from '@/utils/moment'

import { ref, onMounted, computed, toRefs, watch , onBeforeMount } from 'vue'
import { autoResetRef } from '@vueuse/core'
import UniversalInput from '@/components/CRUD/UniversalInput'
import { useRoute, useRouter } from 'vue-router/composables';
import { checkTheRole } from '@/utils/helper'
  
const props = defineProps({
  commissionBatchID: {
    type: Number,
    default: 0,
  },
 
  
 
})


const { commissionBatchID   } = toRefs(props)

const commissionBatchConfig = ref({
  name: 'CommissionBatch',
  label: 'Batch Number',
  type: {
    name: 'autocomplete',
    items: commissionBatchID.value,
  },
})



 
  const coachInfoList = ref([])
  const TempData = ref([])
  const importData = ref({})
  const merge = ref([])
  const peopleFilter = ref(0)
  const peopleFilterConfig = ref({
  name: 'peopleFilter',
  label: 'Coach',
  type: {
    name: 'autocomplete',
    items: coachInfoList.value,
  },
})

 
// courseFromDate.value =   moment().subtract(-90, 'days').format('YYYY-MM-DD')
// courseToDate.value =  moment().format('YYYY-MM-DD') 

const courseFromDate = ref(moment().subtract(0, 'days').format('YYYY-MM-DD'))
const courseToDate = ref('')
const border_1 = ref([])
const startingRowNumber = ref(4)
  

const courseFromDateConfig = ref({
  propName: 'courseFromDate',
  label: 'From Date',
  toplabel: 'Select Course Date',
  type: {
    name: 'datepicker',
  },
}) 
  

//#region JSONheader
const coverHeaderJSON = ref([])
const sheetHeaderJSON = ref([])

const fixOtherPageHeaders = ref([
'Coach Name',
'Position',
'Total',
'Basic Salary',
'Commision Schema',
'Commission % / Amount',
'Commission Total',
'Schema Total',
'Course Total',
'Booking Date',
'Student',
'Price Per Session',
'Order Amount',
'Order Sales %',
 
])

const fixCoverPageHeaders = ref([
'Coach Name',
'Position',
'Total',
'Basic Salary',
'Commision Schema',
'Commission % / Amount',
'Commission Total',
'Schema Total',
])
 

//#endregion


//#region watch


watch(commissionBatchID,  newValue => {
  if (newValue){
    callAPI({UserRecordID : peopleFilter.value ,   theMonth : courseFromDate.value , id: newValue})
  
}
 
coverHeaderJSON.value =  [
  { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
  { Info: 'Coach Name : ALL' , fs: 18 },
  { Info: 'Date : ' +    moment(courseFromDate.value).format('MMM YYYY') , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#2F75B5'  }, // for header row 5
]

  sheetHeaderJSON.value = [
  { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
  { Info: 'Coach Name : ALL' , fs: 18 },
  { Info: 'Date : ' +    moment(courseFromDate.value).format('MMM , YYYY') , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#2F75B5'  }, // for header row 5
 ]
  
})


watch(courseFromDate,  newValue => {

  
  if (newValue && commissionBatchID.value != 0 ){
    callAPI({UserRecordID : coachInfoList.value[peopleFilter.value].userRecordId ,   theMonth : newValue , id : commissionBatchID.value })
    
}

if (newValue && commissionBatchID.value == 0 ){
    callAPI({UserRecordID : coachInfoList.value[peopleFilter.value].userRecordId ,   theMonth : newValue })
    
}
 
coverHeaderJSON.value =  [
  { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
  { Info: 'Coach Name : ALL' , fs: 18 },
  { Info: 'Date : ' +    moment(newValue).format('MMM YYYY') , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#2F75B5'  }, // for header row 5
]

  sheetHeaderJSON.value = [
  { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
  { Info: 'Coach Name : ALL' , fs: 18 },
  { Info: 'Date : ' +    moment(newValue).format('MMM , YYYY') , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#2F75B5'  }, // for header row 5
 ]
  
})

watch(peopleFilter,  newValue => {
  console.log('coachInfoList[peopleFilter.value]',coachInfoList.value[peopleFilter.value].userRecordId)
  if (newValue ){
    callAPI({UserRecordID : coachInfoList.value[peopleFilter.value].userRecordId,   TheMonth : courseFromDate.value , id:commissionBatchID.value})
 
}

if (newValue == false ){
    callAPI({UserRecordID : 0,   TheMonth : courseFromDate.value , id: commissionBatchID.value  })
 
}
 
coverHeaderJSON.value =  [
  { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
  { Info: 'Coach Name : ALL' , fs: 18 },
  { Info: 'Date : ' +    moment(courseFromDate.value).format('MMM , YYYY') , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#2F75B5'  }, // for header row 5
]

  sheetHeaderJSON.value = [
  { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
  { Info: 'Coach Name : ALL' , fs: 18 },
  { Info: 'Date : ' +    moment(courseFromDate.value).format('MMM , YYYY') , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#2F75B5'  }, // for header row 5
 ]
  
})

//#endregion

//#region common functions

function createExcelColumnMap(n) {
  let columnLabel = '';
  let temp = n + 1;
  while (temp > 0) {
    let remainder = (temp - 1) % 26;
    columnLabel = String.fromCharCode(65 + remainder) + columnLabel;
    temp = Math.floor((temp - remainder) / 26);
  }
  return columnLabel;
}

function getFirstDayOfMonth(dateString) {
  const date = moment(dateString)
  const firstDayOfMonth = date.startOf('month')
  const firstDayOfMonthString = firstDayOfMonth.format('YYYY-MM-DD')
  return firstDayOfMonthString
}


function addBorderToManyCell(data ,   { minusRow = 1,   minumumR = 4   ,  style = "1",  color = '#000000'  }) {
 
 let smallestR = Infinity;
   let smallestC = Infinity;

   let largestR = -1;
   let largestC = -1;


   for (let item of data) {
       if (item.r > minumumR && item.r < smallestR) {
           smallestR = item.r;
          
       }
       
       if (item.r > largestR) {
           largestR = item.r;
         
       }
       
       if (item.c < smallestC) {
           smallestC = item.c;
     
       }

       if (item.c > largestC) {
           largestC = item.c;
      
       }
   }

  var borderInfo = [];

  // if (smallestR == Infinity){
  //   smallestR = 0 ;
  // }
 
 borderInfo.push({
   "rangeType": "range",
   "borderType": "border-all",
   "style": style,
   "color":color,
   "range": [{
       "row": [smallestR, largestR - minusRow ],
       "column": [smallestC, largestC]
   }]
   });


return borderInfo

}

function addBorderToCells(data, startingCol, theRow, { style = "1", color = '#000000' }) {

let borderInfo = [];

for (let item of data) {
    if (item.r === theRow && item.c >= startingCol) {
        borderInfo.push({
            "rangeType": "cell",
            "borderType": "border-all",
            "style": style,
            "color": color,
            "valueRange": {
                "row": [item.r],
                "column": [item.c]
            }
        });
    }
}

return borderInfo;
}


function addBorderToSpeicalRow(data ,  startingCol , theRow,  {    style = "1",  color = '#000000' }) {
 
 let smallestR = Infinity;
   let smallestC = Infinity;

   let largestR = -1;
   let largestC = -1;


   for (let item of data) {
 
       if (item.c < smallestC) {
           smallestC = item.c;
     
       }

       if (item.c > largestC) {
           largestC = item.c;
      
       }
   }

  var borderInfo = [];
 
 borderInfo.push({
   "rangeType": "range",
   "borderType": "border-all",
   "style": style,
   "color":color,
   "range": [{
       "row": [theRow, theRow ],
       "column": [startingCol, largestC   ]
   }]
   });


return borderInfo

}

function addBorderToContent(data ,  startingCol , theRow,  {    style = "1",  color = '#000000'  }) {
 
 let smallestR = Infinity;
   let smallestC = Infinity;

   let largestR = -1;
   let largestC = -1;


   for (let item of data) {
 
    if (item.r < smallestR) {
           smallestR = item.r;
     
       }

       if (item.r > largestR) {
           largestR = item.r;
      
       }


       if (item.c < smallestC) {
           smallestC = item.c;
     
       }

       if (item.c > largestC) {
           largestC = item.c;
      
       }
   }

  var borderInfo = [];

  console.log('addBorderToContentR', largestR)
  console.log('addBorderToContentC', largestC)
 
 borderInfo.push({
   "rangeType": "range",
   "borderType": "border-outside",
   "style": style,
   "color":color,
   "range": [{
       "row": [theRow, largestR ],
       "column": [startingCol, largestC   ]
   }]
   });


return borderInfo

}


async function getCoachList(){
  peopleFilter.value = 0
  let tempList = []
  tempList.push({
          id: 0,
          userRecordId : 0 ,
          label: 'ALL',
        }) 

 CoachListForReport({limit: 0  , page : 0 , theMonth : getFirstDayOfMonth(courseFromDate.value)}).then(response => {
  console.log('CoachListForReportresponse',response)

 
  for (let index = 0; index < response.data.items.length; index += 1) {
      const item = response.data.items[index]
      if (item) {
 
        tempList.push({
          id: index + 1 ,
          label: item.user.fullName,
          userRecordId: item.user.id,
        
        })
   
      }
    }
  
   console.log('tempList',tempList)
    // coachInfoList.value = []
    coachInfoList.value =  tempList
  
   peopleFilterConfig.value = { 
  name: 'peopleFilter',
  label: 'Coach',
  type: {
    name: 'autocomplete',
    items: coachInfoList.value,
  },
}
});
}


//#endregion
 

//region headerofotherpage
function isOdd(number) {
  return number % 2 === 1;
}


function headerOfOtherPage(items  ){

  let  { merge ,borderInfo , celldata ,   data , fixHeader ,    sheetHeader  , coachName} =  items
  const bg = '#2F75B5'
  const bgforTotal = '#C65911'
 
  
 
  sheetHeader.forEach((item, row) => {
 if (row < 4) {

  if (row == 1){
 
   const theString = item.Info.replace("ALL", coachName);
    const infoCell = {
     r: row,
     c: 0,
     v: { m: theString, ct: { fa: 'General', t: 's' }, v: theString , fs: item.fs ? item.fs : 12 },
   };
   celldata.push(infoCell);
  }else{
    const infoCell = {
     r: row,
     c: 0,
     v: { m: item.Info, ct: { fa: 'General', t: 's' }, v: item.Info , fs: item.fs ? item.fs : 12 },
   };
   celldata.push(infoCell);

  }



 } 
 
})

 
let row = 5 
const BookingDateIndex = fixHeader.indexOf("Booking Date")
const CourseCountIndex = fixHeader.indexOf("Order Sales %")
console.log('BookingDateIndex',BookingDateIndex)
console.log('CourseCountIndex',CourseCountIndex)
fixHeader.forEach((item, col) => {
  if (col == BookingDateIndex){
    const infoCell = {
     r: row,
     c: col,
     v: { m: 'Detail', ct: { fa: 'General', t: 's' }, v: 'Detail' , fs: item.fs ? item.fs : 12    ,   ht : 0 , bg: bg , fc : '#FFFFFF'},

   };
   celldata.push(infoCell);

   const key = `${row}_${ BookingDateIndex}`;  
        const obj = { rs: 1, cs: CourseCountIndex - BookingDateIndex + 1 , r: row  , c: BookingDateIndex};
        merge[key] = obj;
 

  }
  
  })


row = 6
console.log('fixHeader',fixHeader)
  fixHeader.forEach((item, col) => {
    const infoCell = {
     r: row,
     c: col,
     v: { m: item, ct: { fa: 'General', t: 's' }, v: item , fs: item.fs ? item.fs : 12  , bg: bg ,   fc : '#FFFFFF'},
   };
   celldata.push(infoCell);
 
  })
 
 items.currentRow = row
}


function contentOfOtherPage(items){
  let  { merge ,borderInfo , calcChain , celldata ,   data , fixHeader ,    sheetHeader , currentRow  , sheetIndexPage , coachName } =  items

  const bg = '#2F75B5'
  const bgforTotal = '#C65911'
  const fs = 12
  currentRow = currentRow + 1
 
  const theRowofTotal = currentRow

  let CommissionTotalArray = []
 const thefirstRow = currentRow

  // console.log('data.length', data.length)
  let informationProviderBool = false


  for (let i = 0; i < data.length; i++) {
 
  CommissionTotalArray.push(currentRow)
    const currentRowData = [
    data[i].coachInfo.user.fullName, 
    data[i].coachInfo.position,
    'Total',
    data[i].basicSalary,  // data[i].coachInfo.basicSalary,
    data[i].commissionSchemaType.name,
    [  data[i].calculationUnit,   data[i].calculationUnitIndicator ] ,
  data[i].commissionTotal,
  data[i].schemaTotal,
  data[i].courseCount,
  data[i].coachCommissions,
    // data.Details,
    // data,
   ];


   currentRowData.forEach((value, c) => {
    if (value === undefined)
      {
        value = ''
      }else if  (typeof value === 'string')
      {
        value = !!value ? value.toString() : ''
      }
 


    //data.CoachName ,  data.Position,  
    // && !informationProviderBool 
    if (c <= 1 && !informationProviderBool)
    {
      const infoCell = {
     r: currentRow,
     c: c,
     v: { m: value, ct: { fa: 'General',t: typeof value === 'number' ? 'n' : 's' }, v: value , fs: value.fs ? value.fs : 12      },

   };
   celldata.push(infoCell);

 

   if (c == 1) 
    informationProviderBool = !informationProviderBool
    }

    // data.BasicSalary 
    if ( c == 3){

      const infoCell = {
     r: currentRow,
     c: c,
     v: { m: value, ct: { fa: 'General',t: typeof value === 'number' ? 'n' : 's' }, v: value , fs: value.fs ? value.fs : 12      },

   };
   celldata.push(infoCell);
    }


 // data.CommissionSchema,
    if (  c == 4 || c == 7  || c == 8 )
    {
 
      const infoCell = {
     r: currentRow,
     c: c,
     v: { m: value, ct: { fa: 'General',t: typeof value === 'number' ? 'n' : 's' }, v: value , fs: value.fs ? value.fs : 12      },

   };
   celldata.push(infoCell);
    }


 // data.Commission % / Amount,
 if (  c == 5  )
    {
      let theValue = 0
 if (value[1] == '%')
 {
     theValue = value[0] + '%'
 }else{
  theValue = value[0] 
}

      const infoCell = {
     r: currentRow,
     c: c,
     v: { m: theValue, ct: { fa: 'General',t: typeof value === 'number' ? 'n' : 's' }, v: theValue , fs: theValue.fs ? theValue.fs : 12      },

   };
   celldata.push(infoCell);
    }
 
    //Commission Total
    if (c == 6){
      //BasicSalaryIndex
     const  BasicSalaryIndex = fixHeader.indexOf("Basic Salary")
     const  SchemaTotalIndex = fixHeader.indexOf("Schema Total")
    //  const theFunction = '=123'
      // const theFunction  = `=${createExcelColumnMap(BasicSalaryIndex)}${currentRow + 1 } `
      const theFunction = `=${createExcelColumnMap(BasicSalaryIndex)}${currentRow + 1 } + ${createExcelColumnMap(SchemaTotalIndex)}${currentRow + 1 }`
      const cell = {
              r: currentRow,
              c,
              v: {
                f: theFunction,
                m: 0,
                ct: { fa: 'General', t:  'n'  },
                v: 0,
                fs: value.fs ? value.fs : 12   , 
                ht: 1,
              },
            }
            celldata.push(cell)

            const a =  
              {
                r: currentRow, // the number of rows
                c, // the number of columns
                index: sheetIndexPage, // sheet id
                func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
                color: 'w', // "w"：use Depth-First-Search "b":Normal search
                parent: null,
                chidren: {},
                times: 0,
              } 
  
    calcChain.push(a)
 

    }
 
    //details 
    if (c == 9)
   {
   
 
    for (let ii = 0; ii < value.length; ii++) {
      // console.log('details' , value[ii])
      const detailRowData = [
      value[ii].bookingDate,
      value[ii].studentName,
      value[ii].pricePerSession,
      value[ii].orderAmount,
      value[ii].orderSalesPercentage,
 
   ];
   detailRowData.forEach((theValue , cc ) => 
   {
    //bookingDate
  
    if (cc == 0 ){
    
      theValue =   moment(theValue).utc().format('YYYY-MM-DD')
      console.log('asdasdaaa', theValue)
      const infoCell = {
     r: currentRow,
     c: c + cc,
     v: { m: theValue , ct: { fa: 'yyyy-MM-dd',t: 'd' }, v: theValue  , fs : fs ,ht:2

    },

   };
 
   celldata.push(infoCell);
    }else{
      const infoCell = {
     r: currentRow,
     c: c + cc,
     v: { m: theValue, ct: { fa: 'General',t: typeof tempValue === 'number' ? 'n' : 's' }, v: theValue  , fs : fs   ,ht:2

    },

   };
 
   celldata.push(infoCell);
   if (cc == 4)
    currentRow++
 
    }
  
 
 
   })



    }
  
  }
  

    })
 
}


const theTotalIndex = fixHeader.indexOf("Total")
const CommissionTotalIndex = fixHeader.indexOf("Commission Total")
  //  const currentRowData = [
  //  data[i].coachInfo.user.fullName, 
  //  data[i].coachInfo.position,
  //  '3000',  // data[i].coachInfo.basicSalary,
  //  'Total',
  //   ]
 
//     CommissionTotalArray 
//  thefirstRow 
 let theTotalFunction = '='
 
  CommissionTotalArray.forEach((theValue , c ) => {

    theTotalFunction +=  `${createExcelColumnMap(CommissionTotalIndex)}${theValue + 1}  `
    if (!(c == CommissionTotalArray.length - 1 )) {
      theTotalFunction += ' + '
      }

})
//  theTotalFunction.slice(0 , theTotalFunction.length -1)
console.log('theTotalFunction',theTotalFunction)
//  let theTotalFunction = `=${createExcelColumnMap(BasicSalaryIndex)}${currentRow + 1 } + ${createExcelColumnMap(SchemaTotalIndex)}${currentRow + 1 }`

      const cell = {
              r: thefirstRow,
              c : theTotalIndex,
              v: {
                f: theTotalFunction,
                m: 0,
                ct: { fa: 'General', t:  'n'  },
                v: 0,
                fs:   12   , 
                ht: 1,
                bg: bgforTotal, 
              },
            }
            celldata.push(cell)

            const a =  
              {
                r: thefirstRow,
              c : theTotalIndex,
                index: sheetIndexPage, // sheet id
                func: [true, 0, theTotalFunction], // Formula information, including formula calculation results and formula string
                color: 'w', // "w"：use Depth-First-Search "b":Normal search
                parent: null,
                chidren: {},
                times: 0,
              } 
  
    calcChain.push(a)




}


//#endregion

//#region coverpage
function  jsonToCelldataForCoverPage(items) {
 
 // let  { merge ,borderInfo ,  data , fixHeader   , sheetHeader } =  item  
console.log('item', items)
 let   { merge ,    borderInfo  , celldata ,  calcChain  , data 
    , fixHeader    ,  sheetHeader  ,  sheetIndexPage  , coachName , coverHeader   } = items 

    headerOfCoverPage(items)

 //content
 contentOfCoverPage(items)
 console.log('datadata',items)


}

function  headerOfCoverPage(items) {

  let  { merge ,borderInfo , celldata ,   data , fixHeader ,    coverHeader  , coachName} =  items
  const bg = '#2F75B5'
  const bgforTotal = '#C65911'
 
  
 
  coverHeader.forEach((item, row) => {
 if (row < 4) {

 
    const infoCell = {
     r: row,
     c: 0,
     v: { m: item.Info, ct: { fa: 'General', t: 's' }, v: item.Info , fs: item.fs ? item.fs : 12 },
   };
   celldata.push(infoCell);

  }
})

 

let row = 6
console.log('fixHeader',fixHeader)
  fixHeader.forEach((item, col) => {
    const infoCell = {
     r: row,
     c: col,
     v: { m: item, ct: { fa: 'General', t: 's' }, v: item , fs: item.fs ? item.fs : 12  , bg: bg ,   fc : '#FFFFFF'},
   };
   celldata.push(infoCell);
 
  })
 
 items.currentRow = row


 
}

function  contentOfCoverPage(items) {
  let  { merge ,borderInfo , calcChain , celldata ,   sourcedata , fixHeader ,    sheetHeader , currentRow  , sheetIndexPage , coachName } =  items

const bg = '#2F75B5'
const bgforTotal = '#C65911'
const fs = 12
currentRow = currentRow + 1

const theRowofTotal = currentRow
let   addGreyColor = false


let sourcedataCounter = 0 
for (const coachInfoID in sourcedata) {
    const data = sourcedata[coachInfoID];
    let CommissionTotalArray = []
    const thefirstRow = currentRow
    if (data){
      addGreyColor = isOdd(sourcedataCounter)
 
 console.log('addGreyColor', addGreyColor)
 sourcedataCounter ++
    }
let informationProviderBool = false
 console.log('coachInfoIDdata',data)

 const mergeCurrentRow = currentRow
 
 if (data.length > 1 )
 {
  for (let i = 0; i < 3; i++) {
  const key = `${mergeCurrentRow}_${i}`;
  const obj = { rs: data.length, cs: 1, r: mergeCurrentRow, c: i };
  merge[key] = obj;
}
 }


    for (let i = 0; i < data.length  ; i++) {
 
CommissionTotalArray.push(currentRow)
  const currentRowData = [
  data[i].coachInfo.user.fullName, 
  data[i].coachInfo.position,
  'Total',
  data[i].basicSalary,  // data[i].coachInfo.basicSalary,
  data[i].commissionSchemaType.name,
  [  data[i].calculationUnit,   data[i].calculationUnitIndicator ] ,
data[i].commissionTotal,
data[i].schemaTotal,
data[i].courseCount,
data[i].coachCommissions,
  // data.Details,
  // data,
 ];

 console.log('coverPage', currentRowData)



 currentRowData.forEach((value, c) => {
  if (value === undefined)
    {
      value = ''
    }else if  (typeof value === 'string')
    {
      value = !!value ? value.toString() : ''
    }

  //data.CoachName ,  data.Position,   data.BasicSalary 
  if (c <= 1  && !informationProviderBool )
  {
    const infoCell = {
   r: currentRow,
   c: c,
   v: { m: value, ct: { fa: 'General',t: typeof value === 'number' ? 'n' : 's' }, v: value , fs: value.fs ? value.fs : 12  
   , ... c == 3 ? { ht: 2}:   {}
  ,  ...addGreyColor ? {bg : '#D9D9D9' } :  {} 
  }, 

 };
 celldata.push(infoCell);

 if (c == 1) { 
  informationProviderBool = !informationProviderBool
 
  }


 
  }

  //basic Salary
  if ( c == 3 )
  {
    const infoCell = {
   r: currentRow,
   c: c,
   v: { m: value, ct: { fa: 'General',t: typeof value === 'number' ? 'n' : 's' }, v: value , fs: value.fs ? value.fs : 12  
   , ... c == 3 ? { ht: 2}:   {}
  ,  ...addGreyColor ? {bg : '#D9D9D9' } :  {} 
  }, 

 };
 celldata.push(infoCell);
  }


  

// data.CommissionSchema,
if (  c == 4 || c == 7   )
  {

    const infoCell = {
   r: currentRow,
   c: c,
   v: { m: value, ct: { fa: 'General',t: typeof value === 'number' ? 'n' : 's' }, v: value , fs: value.fs ? value.fs : 12   ,
   ... c == 7 ? { ht: 2}:   {}
  ,...addGreyColor ? {bg : '#D9D9D9' } :  {} },

 };
 celldata.push(infoCell);

if (c == 7)
  currentRow ++

  }

// data.Commission % / Amount,
if (  c == 5  )
  {
    let theValue = 0
    console.log()
if (value[1] == '%')
{
   theValue = value[0] + '%'
}else{
  theValue = value[0] 
}

    const infoCell = {
   r: currentRow,
   c: c,
   v: { m: theValue, ct: { fa: 'General',t: typeof value === 'number' ? 'n' : 's' }, v: theValue , fs: theValue.fs ? theValue.fs : 12  ,
  ht: 2  
  ,...addGreyColor ? {bg : '#D9D9D9' } :  {} },

 };
 celldata.push(infoCell);
  }
 
  if (c == 6){
    //BasicSalaryIndex
   const  BasicSalaryIndex = fixHeader.indexOf("Basic Salary")
 
   const  SchemaTotalIndex = fixHeader.indexOf("Schema Total")
 
 
    const theFunction = `=${createExcelColumnMap(BasicSalaryIndex)}${currentRow + 1 } + ${createExcelColumnMap(SchemaTotalIndex)}${currentRow + 1 }`
console.log('cctheFunction',theFunction)
   const cell = {
            r: currentRow,
            c,
            v: {
              f: theFunction,
              m: 0,
              ct: { fa: 'General', t:  'n'  },
              v: 0,
              fs: value.fs ? value.fs : 12   , 
              ht: 2,
               ...addGreyColor ? {bg : '#D9D9D9' } :  {} 
            },
          }
          celldata.push(cell)

          const a =  
            {
              r: currentRow, // the number of rows
              c, // the number of columns
              index: 0, // sheet id
              func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
              color: 'w', // "w"：use Depth-First-Search "b":Normal search
              parent: null,
              chidren: {},
              times: 0,
            } 

  calcChain.push(a)

  }


  //Total
  const theTotalIndex = fixHeader.indexOf("Total")
const CommissionTotalIndex = fixHeader.indexOf("Commission Total")
 
//     CommissionTotalArray 
//  thefirstRow 
 let theTotalFunction = '='
 
  CommissionTotalArray.forEach((theValue , c ) => {

    theTotalFunction +=  `${createExcelColumnMap(CommissionTotalIndex)}${theValue + 1}  `
    if (!(c == CommissionTotalArray.length - 1 )) {
      theTotalFunction += ' + '
      }

}) 
      const cell = {
              r: thefirstRow,
              c : theTotalIndex,
              v: {
                f: theTotalFunction,
                m: 0,
                ct: { fa: 'General', t:  'n'  },
                v: 0,
                fs:   12   , 
                ht: 2,
                bg: bgforTotal, 
              },
            }
            celldata.push(cell)

            const a =  
              {
                r: thefirstRow,
              c : theTotalIndex,
                index: 0, // sheet id
                func: [true, 0, theTotalFunction], // Formula information, including formula calculation results and formula string
                color: 'w', // "w"：use Depth-First-Search "b":Normal search
                parent: null,
                chidren: {},
                times: 0,
              } 
  
    calcChain.push(a)
 
  })

 
}


     



}

 //Grand Total
 const  GrandTotalWordIndex = fixHeader.indexOf("Commission % / Amount")
 
 const  GrandTotalIndex  = fixHeader.indexOf("Commission Total")
  //Grand Total word
  const cellGrandTotalword = {
              r: currentRow,
              c : GrandTotalWordIndex,
              v: {
                m: 'Grand Total: ',
                ct: { fa: 'General', t:  'n'  },
                v: 'Grand Total: ',
                fs:   12   , 
                ht: 1,
                bg: bgforTotal, 
              },
            }
            celldata.push(cellGrandTotalword)
      
  let theFunction = '='
  
  for (let i = theRowofTotal ; i < currentRow ; i++) {
 
  theFunction +=  `${createExcelColumnMap(GrandTotalIndex)}${i + 1  }  `
   if (!(i == currentRow - 1    )) {
    theFunction += ' + '
     }
 
  }

  const cellGrandTotal = {
              r: currentRow,
              c : GrandTotalIndex,
              v: {
                f: theFunction,
                m: 0,
                ct: { fa: 'General', t:  'n'  },
                v: 0,
                fs:   12   , 
                ht: 2,
                bg: bgforTotal, 
              },
            }
            celldata.push(cellGrandTotal)
      
            const a =  
            {
              r: currentRow, // the number of rows
              c : GrandTotalIndex, // the number of columns
              index: 0, // sheet id
              func: [true, 0, theFunction], // Formula information, including formula calculation results and formula string
              color: 'w', // "w"：use Depth-First-Search "b":Normal search
              parent: null,
              chidren: {},
              times: 0,
            } 

  calcChain.push(a)




}
//#endregion



//#region otherpage
function  jsonToCelldata(item) {
 
  // let  { merge ,borderInfo ,  data , fixHeader   , sheetHeader } =  item  
console.log('item', item)
  let   { merge ,    borderInfo  , celldata ,  calcChain  , data   , fixHeader    ,  sheetHeader  ,  sheetIndexPage  , coachName  } = item 
 
  headerOfOtherPage(item)

  //content
  contentOfOtherPage(item)
  console.log('datadata',item)

 
}

//#endregion



// watch(peopleFilter,  newValue => {
//   if (newValue){
//     callAPI({UserRecordID : peopleFilter.value , ToDate: courseToDate.value , FromDate : courseFromDate.value})
 
// }  
// }
 
// )

// watch(courseFromDate,  newValue => {
//   if (newValue){
//     callAPI({UserRecordID : peopleFilter.value , ToDate: courseToDate.value , FromDate : newValue})
   
  
// }

// coverHeaderJSON.value =  [
//   { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
//   { Info: 'Coach Name : ALL' , fs: 18 },
//   { Info: 'Date : ' + newValue + ' to ' +  courseToDate.value ,fs: 16 },
//   { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
//   { Info: '' }, // Empty row
//   { Info: '' , bg : '#808080'  }, // for header row 5
//   // #D9D9D9  other gray
//   ]
 

// }
 
// )

// watch(courseToDate,  newValue => {
//   if (newValue){
//     callAPI({UserRecordID : peopleFilter.value , ToDate: newValue, FromDate : courseFromDate.value})
    
// }

// coverHeaderJSON.value =  [
//   { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
//   { Info: 'Date : ' + courseFromDate.value + ' to ' +  newValue ,fs: 16 },
//   { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
//   { Info: '' }, // Empty row
//   { Info: '' , bg : '#808080'  }, // for header row 5
//   // #D9D9D9  other gray
//   ]

  
// } 
 
// )


onMounted( async ( ) => {
 try{
  const route = useRoute();
 
  console.log('route',route)
    const paramValue = parseInt(route.query.commissionBatchID) 
 console.log('paramValue',route.query.commissionBatchID)

 if (route.query.commissionBatchID)
    commissionBatchID.value = paramValue
 
 }catch (ex)
 {
  console.log('error',ex)
 }



 console.log('courseFromDate',courseFromDate.value)

 getCoachList()
 
 

})

function handleCourseFromDateInput(dateValue) {
 console.log('dateValue',dateValue )
}

function handleCourseToDateInput(dateValue) {
  console.log('dateValue',dateValue )
}


function addBgToPreSecondLockerID(lockers) {
  let addColor = false // if true add color
  let tempID = 0
  try
  {
    tempID = lockers[0].lockerID;
  }catch
  {

  }
 
  for (let i = 0; i < lockers.length; i++) {
    

    if (i == 0)
    {

    }
    else{
       if (lockers[i].lockerID != tempID){
        addColor = !addColor
        tempID = lockers[i].lockerID 
       }


      if (addColor)
       lockers[i].bg = '#D9D9D9';
 
    }

 
  }
 
  return lockers;
}
 

function addBgToEverySecondRow(lockers) {
  for (let i = 0; i < lockers.length; i++) {
    if ((i%2) != 0)
       lockers[i].bg = '#D9D9D9';
  }
    
  return lockers;
}
 
function generateMergeJson(data, rowOffset, columnOffset) {
  const mergeJson = {};
  const mergeStart = {};
  const keysToMerge = ["lockerNo", "lockerSize", "lockerStatus" , "currentUser"];

  data.forEach((row, i) => {
    let lockerIdMatch = true;
    if (i === 0 || row["lockerID"] !== data[i - 1]["lockerID"]) {
      lockerIdMatch = false;
    }

    if (lockerIdMatch) {
      keysToMerge.forEach((key) => {
        mergeStart[key] = (mergeStart[key] || 0) + 1;
      });
    } else {
      keysToMerge.forEach((key, j) => {
        if (mergeStart[key] && mergeStart[key] > 1) {
          const mergeKey = `${i - mergeStart[key] + rowOffset}_${j + columnOffset}`;
          mergeJson[mergeKey] = {
            rs: mergeStart[key],
            cs: 1,
            r: i - mergeStart[key] + rowOffset,
            c: j + columnOffset,
          };
        }
        mergeStart[key] = 1;
      });
    }
  });

  keysToMerge.forEach((key, j) => {
    if (mergeStart[key] && mergeStart[key] > 1) {
      const mergeKey = `${data.length - mergeStart[key] + rowOffset}_${j + columnOffset}`;
      mergeJson[mergeKey] = {
        rs: mergeStart[key],
        cs: 1,
        r: data.length - mergeStart[key] + rowOffset,
        c: j + columnOffset,
      };
    }
  });

  return  mergeJson ;
}



function convertTimestamp(timestamp) {
  const momentObj = moment(timestamp);
  const formattedDate = momentObj.format('DD/MM/YYYY');
  const formattedTime = momentObj.format('hh:mm:ss A');

  return `${formattedDate} ${formattedTime}`;
}

function convertTransactionDates(json) {
  json.forEach(obj => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && moment(obj[key], moment.ISO_8601).isValid()) {
        const momentObj = moment(obj[key]);
        const formattedDate = momentObj.format('DD/MM/YYYY hh:mm:ss A');
        obj[key] = formattedDate;
      }
    }
  });
  return json;
}

function calculateColumnWidths(celldata) {
  const colWidths = {};

  celldata.forEach((cell) => {
    const { c, v } = cell;
    const content = v.v;
    const fontSize =    cell.v.fs ?  cell.v.fs  :  12
    // const width = content.toString().length * 10 * fontSize/10; // 10 is an approximate width per character
    // const width = content.toString().length *  fontSize /1.15;
   

    let width = 73
    if (content){
      width = content.toString().length * fontSize / 1.2
      if (width <= 73) {
      width = 73
    }
   
    }
 

    if (!colWidths[c] || width > colWidths[c]) {
      colWidths[c] = width;
    }
  });
 
  return colWidths;
 
}

function calculateColumnHeights(celldata) {
  const colHeights = {};

  celldata.forEach((cell) => {
    
    const { c, r } = cell;
    // const content = v.v;
    // const lines = content.toString().split(/\r\n|\r|\n/).length; // Count the number of lines in the content
    const fontSize =    cell.v.fs ?  cell.v.fs  :  12
    const lineHeight = fontSize * 1.4; // Calculate the line height based on the font size, assuming 1.2x the font size as a standard
    const height = lineHeight;

    if (!colHeights[r] || height > colHeights[r]) {
      colHeights[r] = height;
    }
  });

  return colHeights;
}

 

function initCoverPage(data , theMonth){
   
  coverHeaderJSON.value =  [
  { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
  { Info: 'Coach Name : ALL' , fs: 18 },
  { Info: 'Date : ' +    moment(theMonth).format('MMM YYYY') , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#2F75B5'  }, // for header row 5
]
 

  let merge = []
    let borderInfo = []
    let calcChain = []
    let  celldata = []
    let coachName = ''
 let sheets  = []
    let  item = { merge ,borderInfo  ,  celldata,  calcChain  , sourcedata : data , fixHeader : fixCoverPageHeaders.value   , 
     sheetHeader : sheetHeaderJSON.value   ,  
     coverHeader : coverHeaderJSON.value
    }
     console.log('initOtherPageitem',item)
     jsonToCelldataForCoverPage(item);
    
     
     const colWidths = calculateColumnWidths(item.celldata);
    const colHeights = calculateColumnHeights(item.celldata);

 
    // borderInfo =   [...borderInfo , ... addBorderToSpeicalRow(celldata , 9,   5,  {  style :1,   color :'#000000' })] 
    // borderInfo =   [...borderInfo , ... addBorderToSpeicalRow(celldata , 0,   6,  {style : 1,   minusRow : 1,   minumumR : 6 ,     color : '#000000' })] 
    // borderInfo =   [...borderInfo , ... addBorderToContent(celldata , 0,   7,  {style : 1,   minusRow : 1,   minumumR : 6 ,     color :'#000000' })] 
 
// console.log('borderInfo',borderInfo)
// console.log('calcChain',calcChain)
    sheets.push({
            name: 'Cover',
            status: 1,
            index : 0,
            celldata, 
            calcChain , 
            config: {
          // authority: { // 当前工作表的权限配置
          //   sheet:sheetIndex + 1 , // sheet表下标。
          //   hintText: 'You can not edit any cell', // 弹窗提示的文字
          // },
          rowlen: {}, // Table row height
          columnlen: colWidths,
          rowlen: colHeights, // Table row height
          rowhidden: {}, // hidden rows
          colhidden: {}, // hidden columns
          merge:  merge,
          borderInfo: borderInfo,
     
        },
   
      });
    
 
    
 
  return sheets
 
   
}

function initOtherPage(data, theMonth)
{
  sheetHeaderJSON.value = [
  { Info: 'Monthly Sales Report - Personal by Monthly' , fs: 18 },
  { Info: 'Coach Name : ALL' , fs: 18 },
  { Info: 'Date : ' +    moment(theMonth).format('MMM YYYY') , fs: 16 },
  { Info: 'Print Date : ' + moment().format('YYYY-MM-DD HH:mm') ,  fs: 12  },
  { Info: '' }, // Empty row
  { Info: '' , bg : '#2F75B5'  }, // for header row 5
 ]
 
  console.log('initOtherPagefordata',data)
   let sheets = []

   let sheetIndex = 1 
   for (const coachInfoID in data) {
    const summaries = data[coachInfoID];

    // Perform operations on each group of summaries
    console.log(`CoachInfoID: ${coachInfoID}`);
    console.log('summaries',summaries);
    console.log('---');


    let merge = []
    let borderInfo = []
    let calcChain = []
    let  celldata = []
    let coachName = ''
    let sheetIndexPage = sheetIndex + 1 
    let  item = { merge ,borderInfo  ,  celldata,  calcChain  , data : summaries , fixHeader : fixOtherPageHeaders.value   , 
     sheetHeader : sheetHeaderJSON.value , sheetIndexPage , coachName : summaries[0].coachInfo.user.fullName }
     console.log('initOtherPageitem',item)
    jsonToCelldata(item);
     
     const colWidths = calculateColumnWidths(item.celldata);
    const colHeights = calculateColumnHeights(item.celldata);

 
    borderInfo =   [...borderInfo , ... addBorderToSpeicalRow(celldata , 9,   5,  {  style :1,   color :'#000000' })] 
    borderInfo =   [...borderInfo , ... addBorderToSpeicalRow(celldata , 0,   6,  {style : 1,   minusRow : 1,   minumumR : 6 ,     color : '#000000' })] 
    borderInfo =   [...borderInfo , ... addBorderToContent(celldata , 0,   7,  {style : 1,   minusRow : 1,   minumumR : 6 ,     color :'#000000' })] 
 
console.log('borderInfo',borderInfo)
console.log('calcChain',calcChain)
    sheets.push({
            name: summaries[0].coachInfo.user.fullName.replace(/[\*\?:\\/\[\]]/g, ',') ,
            status: 1,
            index : sheetIndexPage,
            celldata, 
            calcChain , 
            config: {
          // authority: { // 当前工作表的权限配置
          //   sheet:sheetIndex + 1 , // sheet表下标。
          //   hintText: 'You can not edit any cell', // 弹窗提示的文字
          // },
          rowlen: {}, // Table row height
          columnlen: colWidths,
          rowlen: colHeights, // Table row height
          rowhidden: {}, // hidden rows
          colhidden: {}, // hidden columns
          merge:  merge,
          borderInfo: borderInfo,
     
        },
   
      });
    
    sheetIndex++
    
  }
  return sheets
 

  // for (let sheetIndex = 0; sheetIndex < data.length; sheetIndex++)
  // {
  //   console.log('initOtherPagesss',data[sheetIndex]) 

   

  //     console.log('sheetinformation', sheets)

     
  // }

  

  // const colWidths = calculateColumnWidths(celldata);
  // const colHeights = calculateColumnHeights(celldata);
  // console.log('colHeights', colHeights);

  // border_1.value = [...border_1.value , ...addBorderToManyCell(celldata , { minumumR : startingRowNumber.value - 1 , minusRow: 0 })] 


}

function initLuckysheet(data ,theMonth )
{
 let sheets = []
 
//  const coverSheet =  initCoverPage(data)
const otherSheets = initOtherPage(data , theMonth)
sheets = [...sheets , ...otherSheets] 
if (checkTheRole([5,7])){
  const coverSheets = initCoverPage(data, theMonth )
 
sheets = [...coverSheets , ...sheets] 
 


}
   // Construct the options object
   var options = {
       container: 'luckysheet',
       title: 'Stress Test',
       lang: 'zh',
    
       showsheetbar: true,
       forceCalculation: true,
 
       data: sheets
   };

 return options
}
 
  function callAPI(data){
 
if (commissionBatchID.value != 0)
{
     data.id = commissionBatchID.value
  
}


showExcel(data)
     .then(response => {
 
      let newArray =  response.data.record;

      const coachCommissionSummaries = response.data.record.coachCommissionSummaries;

        // Group the coachCommissionSummaries array by coachInfoID
        const groupedByCoachInfoID = coachCommissionSummaries.reduce((result, summary) => {
            const coachInfoID = summary.coachInfoID;

            if (!result[coachInfoID]) {
                result[coachInfoID] = []; 
            }

            result[coachInfoID].push(summary);

            return result;
        }, {});

        console.log('groupedByCoachInfoID', groupedByCoachInfoID);

        const theMonth = response.data.record.selectedMonth

      const temp =  initLuckysheet(groupedByCoachInfoID,theMonth)



    console.log('temp',temp)
    importData.value = temp

     }).catch(exception => { 

      console.log('exception',exception)

      })

     
//       const simulateData = [
//     {
//         "CoachName": "Sing Wong",
//         "Position": "Freelance",
//         "BasicSalary": 3000,
//         "CommissionSchema": "F1",
//         "CommissionPercentage": "22%",
//         "Commission Total": 638.00,
//         "CommissionAmount": 638,
//         "Details": [
//             {
//                 "BookingDate": "2023-06-01",
//                 "Student": "Student A",
//                 "PricePerSession": 800,
//                 "OrderAmount": null,
//                 "OrderSales%": null,
//                 "CourseCount": null
//             },
//             {
//                 "BookingDate": "2023-06-12",
//                 "Student": "Student A",
//                 "PricePerSession": 900,
//                 "OrderAmount": null,
//                 "OrderSales %": null,
//                 "CourseCount": null
//             },
//             {
//                 "BookingDate": "2023-06-23",
//                 "Student": "Student A",
//                 "PricePerSession": 1200,
//                 "OrderAmount": null,
//                 "OrderSales%": null,
//                 "CourseCount": null
//             }
//         ]
//     }
// ]

 



 

      
    // initLuckysheet(newValue)
    //  })
     
    //  .catch(err => {  
    //   console.log('err',err)
    //   })
  }
 


 
</script>